'use client';
import { useEffect, useState } from 'react';
import { ChevronDown } from 'react-feather';
import { useRouter, usePathname } from 'next/navigation';

import classes from './FilterComps.module.css';

const MaterialFilter = (props) => {
	const { theMaterial, uniqueMaterials } = props;

	const router = useRouter();
	const pathname = usePathname();

	const [showMaterials, setShowMaterials] = useState(false);
	const [showAll, setShowAll] = useState(false);

	const [materials, setMaterials] = useState([]);

	useEffect(() => {
		if (uniqueMaterials) {
			let materialsArr = Object.entries(uniqueMaterials)
				// 2. Filter the styles that have count > 2.
				.filter(([key, count]) => count > 2)
				.sort((a, b) => b[1] - a[1]);
			setMaterials(materialsArr);
		}
	}, [uniqueMaterials]);

	const showHandler = () => {
		setShowMaterials(!showMaterials);
	};

	const styleHandler = (material) => {
		let newParams = new URLSearchParams(window.location.search);

		if (theMaterial === material) {
			newParams.delete('material');
		} else {
			newParams.set('material', material);
		}

		router.replace(pathname + '?' + newParams.toString());
	};

	const capitalizeEachWord = (text) => {
		const specialCases = {
			'1980_s': '1980s',
			'1990_s': '1990s',
			'20_th_century': '20th Century',
		};

		if (specialCases[text]) {
			return specialCases[text];
		}

		// For words that aren't special cases
		return text
			.replace(/_/g, ' ')
			.split(' ')
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');
	};

	return (
		<>
			<div className={classes.desktop}>
				<div className={classes.dropDown}>
					<div onClick={showHandler} className={classes.justifyBetween}>
						Material
						<ChevronDown
							size={13}
							className={showMaterials ? classes.flip : classes.icon}
						/>
					</div>
					{showMaterials && (
						<div className={classes.box}>
							{materials.map(([key, count], id) => {
								// Only show the style if we're showing all or if it's in the first 6
								if (!showAll && id >= 6) return null;

								return (
									count > 1 && (
										<div
											className={
												theMaterial === key ? classes.active : classes.selection
											}
											key={key}
											value={key}
											onClick={() => styleHandler(key)}
										>
											<h3 className={classes.underline}>
												{capitalizeEachWord(key)}{' '}
											</h3>
											<span className={classes.count}>
												(
												{count.toLocaleString(undefined, {
													maximumFractionDigits: 2,
												})}
												)
											</span>
										</div>
									)
								);
							})}

							{/* Toggle between "Show X more" and "Show less" */}
							{showAll ? (
								<button
									className={classes.showMoreButton}
									onClick={() => setShowAll(false)}
								>
									Show less
								</button>
							) : materials.length - 6 > 0 ? (
								<button
									className={classes.showMoreButton}
									onClick={() => setShowAll(true)}
								>
									Show {materials.length > 6 ? materials.length - 6 : ''} more
								</button>
							) : (
								''
							)}
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default MaterialFilter;
